<template>
	<v-tooltip bottom :disabled="!isTruncated">
		<template v-slot:activator="{ on, attrs }">
			<div
				v-bind="attrs"
				v-on="on"
				class="text-truncate"
				@mouseenter="checkTruncation"
				ref="content"
			>
				<slot></slot>
			</div>
		</template>
		<span><slot></slot></span>
	</v-tooltip>
</template>

<script>
export default {
	name: "TruncateTooltip",
	data() {
		return {
			isTruncated: false,
		};
	},
	mounted() {
		this.$nextTick(() => this.checkTruncation());
	},
	updated() {
		this.$nextTick(() => this.checkTruncation());
	},
	methods: {
		checkTruncation() {
			const el = this.$refs.content;
			if (el) {
				this.isTruncated = el.scrollWidth > el.clientWidth;
			}
		},
	},
};
</script>
